module.exports = __webpack_public_path__ + "static/38-3724cefc27c50e52d287825f3ae2ee59.jpg";